/**
 * HTTP common utility functions
 */
import axios from 'axios';
import { message } from 'antd';

/**
 * Common GET request
 * @param url       API URL
 * @param msg       API error message
 * @param headers   Required header configuration
 */

export const get = ({ url, params, msg = 'Interface exception', headers }) =>
    axios.get(url, { params }, headers).then(res => res.data).catch(err => {
        message.warn(msg);
        throw err;
    });


// Pagination GET method
export const getList = ({ url, params, msg = 'Interface exception', headers }) =>
    axios.get(url, { params }, headers).then(res => {
        var headers = { per_total: 0, per_page: 0, page: 0, page_count: 0 }
        headers.per_page = parseInt(res.headers['x-pagination-per-page'])
        headers.per_total = parseInt(res.headers['x-pagination-total-count'])
        headers.page_count = parseInt(res.headers['x-pagination-page-count'])
        headers.page = parseInt(res.headers['x-pagination-current-page'])
        res.data.headers = headers
        return res.data
    }).catch(err => {
        message.warn(msg);
        throw err;
    });


/**
 * Common POST request
 * @param url       API URL
 * @param data      API parameters
 * @param msg       API error message
 * @param headers   Required header configuration
 */
export const post = ({ url, data, msg = 'Interface exception', headers}) =>
    axios.post(url, data, headers).then(res => res.data).catch(err => {
        message.warn(msg);
        throw err;
    });


/**
 * Common PUT request
 * @param url       API URL
 * @param data      API parameters
 * @param msg       API error message
 * @param headers   Required header configuration
 */
export const put = ({ url, data, msg = 'Interface exception', headers }) =>
    axios.put(url, data, headers).then(res => res.data).catch(err => {
        message.warn(msg);
        throw err;
    });

/**
 * Common DELETE request
 * @param url       API URL
 * @param data      API parameters
 * @param msg       API error message
 * @param headers   Required header configuration
 */
export const DELETE = ({ url, data, msg = 'Interface exception', headers }) =>
    axios.delete(url, { data }, headers).then(res => res.data).catch(err => {
        message.warn(msg);
        throw err;
    });
